// export default ['成功', '处理中','失败','待执行'];
// 未执行 处理中 成功 失败
export default [
    {
        text:'未执行',
        color:'yellow-text',
    }, {
        text:'处理中',
        color:'yellow-text',
    }, {
        text:'成功',
        color:'green-text',
    }, {
        text:'失败',
        color:'red-text',
    }];
// {
//   text:'成功',
//     color:'green-text',
// }, {
//   text:'处理中',
//     color:'yellow-text',
// }, {
//   text:'失败',
//     color:'red-text',
// }, {
//   text:'待支付',
//     color:'yellow-text',
// }, {
//   text:'未发送',
//     color:'yellow-text',
// },{
//   text:'待退款',
//     color:'yellow-text',
// } ,{
//   text:'退款中',
//     color:'yellow-text',
// }, {
//   text:'退款失败',
//     color:'red-text',
// }, {
//   text:'查询中',
//     color:'yellow-text',
// }, {
//   text:'异常终止',
//     color:'red-text',
// }



// WEBPACK FOOTER //
// ./src/service/constant/planDetailStatus.js